import sample from "lodash/sample";
import random from "lodash/random";
import { ARBITRUM, BSC, AVALANCHE_FUJI, BESC } from "./chains";

// BESC uses our own indexer as the oracle keeper endpoint.
// For V1 GMX contracts (which MoneyX uses), oracle keeper is a V2 concept and
// won't be called for trade execution — prices come from on-chain Chainlink feeds.
// The URL is still required by SettingsContextProvider initialization.
// ?? only catches null/undefined; use || so an empty VITE_INDEXER_API string also falls back.
// In dev, the fallback is a relative "/api" — Vite proxies /api → localhost:8011.
// In production, set VITE_INDEXER_API=https://your-indexer-domain.com
const _bescIndexerBase =
  (import.meta.env.VITE_INDEXER_API as string | undefined) || "";
const BESC_INDEXER_URL = _bescIndexerBase.replace(/\/+$/, "") + "/api";

const ORACLE_KEEPER_URLS: Record<number, string[]> = {
  [ARBITRUM]: ["https://arbitrum-api.gmxinfra.io", "https://arbitrum-api.gmxinfra2.io"],

  [BSC]: ["https://avalanche-api.gmxinfra.io", "https://avalanche-api.gmxinfra2.io"],

  [AVALANCHE_FUJI]: ["https://synthetics-api-avax-fuji-upovm.ondigitalocean.app"],

  [BESC]: [BESC_INDEXER_URL],
};

export function getOracleKeeperUrl(chainId: number, index: number) {
  const urls = ORACLE_KEEPER_URLS[chainId];

  if (!urls || !urls.length) {
    return "";
  }

  return urls[index] || urls[0];
}

export function getOracleKeeperNextIndex(chainId: number, currentIndex: number) {
  const urls = ORACLE_KEEPER_URLS[chainId];

  if (!urls || !urls.length) {
    return 0;
  }

  return urls[currentIndex + 1] ? currentIndex + 1 : 0;
}

export function getOracleKeeperRandomIndex(chainId: number, bannedIndexes?: number[]): number {
  const urls = ORACLE_KEEPER_URLS[chainId];

  if (!urls || !urls.length) {
    return 0;
  }

  if (bannedIndexes?.length) {
    const filteredUrls = urls.filter((_url, i) => !bannedIndexes.includes(i));

    if (filteredUrls.length) {
      const url = sample(filteredUrls);
      return urls.indexOf(url!);
    }
  }

  return random(0, urls.length - 1);
}
